import { IconCalendar } from "../../../components/icons/IconsPaciente";
import { EmptyState } from "../../../components/utils/Utils";

// Paso 3: lista de fechas (dias) con turnos, ya ordenadas cronologicamente.
const PasoFecha = ({ fechas, onElegir }) => (
    <div className="wizard-paso">
        <h3 className="wizard-paso__titulo">Elegí una fecha</h3>
        {fechas.length === 0 ? (
            <EmptyState icon={<IconCalendar />} title="No hay fechas con turnos disponibles." />
        ) : (
            <div className="wizard-lista">
                {fechas.map((fecha) => (
                    <button key={fecha.clave} type="button" className="wizard-lista__item" onClick={() => onElegir(fecha.clave)}>
                        <IconCalendar />
                        <span>{fecha.label}</span>
                    </button>
                ))}
            </div>
        )}
    </div>
);

export default PasoFecha;
